var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar-week"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M1.25,6V18.5A1.25,1.25,0,0,0,2.5,19.75h15a1.25,1.25,0,0,0,1.25-1.25V6ZM2.5,2.25A2.5,2.5,0,0,0,0,4.75V18.5A2.5,2.5,0,0,0,2.5,21h15A2.5,2.5,0,0,0,20,18.5V4.75a2.5,2.5,0,0,0-2.5-2.5Z",
    transform: "translate(0 -1)",
    fill: "#74613c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M7.375,0A.625.625,0,0,1,8,.625V1.25a.625.625,0,0,1-1.25,0V.625A.625.625,0,0,1,7.375,0Zm11.25,0a.625.625,0,0,1,.625.625V1.25a.625.625,0,0,1-1.25,0V.625A.625.625,0,0,1,18.625,0Z",
    transform: "translate(-3)",
    fill: "#74613c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M16.75,14.125a.625.625,0,0,1,.625-.625h1.25a.625.625,0,0,1,.625.625v1.25a.625.625,0,0,1-.625.625h-1.25a.625.625,0,0,1-.625-.625Zm-3.75,0a.625.625,0,0,1,.625-.625h1.25a.625.625,0,0,1,.625.625v1.25a.625.625,0,0,1-.625.625h-1.25A.625.625,0,0,1,13,15.375Zm-6.25,3.75a.625.625,0,0,1,.625-.625h1.25a.625.625,0,0,1,.625.625v1.25a.625.625,0,0,1-.625.625H7.375a.625.625,0,0,1-.625-.625Zm3.75,0a.625.625,0,0,1,.625-.625h1.25a.625.625,0,0,1,.625.625v1.25a.625.625,0,0,1-.625.625h-1.25a.625.625,0,0,1-.625-.625Z",
    transform: "translate(-3 -6)",
    fill: "#74613c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSession);
export default __webpack_public_path__ + "static/media/session.bf1676e8bd204b360ed272b68c804af4.svg";
export { ForwardRef as ReactComponent };